import './main.less';
import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
	intl: PropTypes.func,
	attachments: PropTypes.array,
	attachmentsUpload: PropTypes.func,
	attachmentsDelete: PropTypes.func,
	attachmentsSave: PropTypes.func
};

const Attachments = props => (
	<div className="affiliate-attachment">
		<div className="affiliate-attachment__control">
			<p className="placeholder">{props.intl('Attach files')}</p>
			<input
				type="file"
				className="control"
				multiple={true}
				onChange={e => props.attachmentsUpload(e.target.files)}/>
		</div>

		<div className="affiliate-attachment__files">
			{ props.attachments.map((file, index) => (
				<div className="file" key={index}>
					<span
						className="file__remove"
						onClick={
							() => confirm(props.intl('Remove file %s', '?')) && props.attachmentsDelete(index)
						} />
					<img src={file} alt=""/>
				</div>
			)) }
		</div>

		<div className="affiliate-attachment__btn">
			<button
				className="ui-btn ui-btn-primary"
				onClick={props.attachmentsSave}>
				{props.intl('Save')}
			</button>
		</div>

	</div>
);

Attachments.propTypes = propTypes;
export default Attachments;




// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/forms/attachments/main.js